// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2cKVL","colMin":"styles_colMin__gmT2j","colCheckbox":"styles_colCheckbox__1wZRm"};